<script lang="ts">
  import { DropdownItem } from '$lib/components/common/dropdowns/dropdown';
  import TopDonorsPedastol from './TopDonorsPedastol.svelte';
  import TopDonorItem from './TopDonorItem.svelte';
  import Rays from './rays.svg.svelte';
  import {
    fetchTopDonorsItems,
    type TopDonorsItem,
    type TopDonorsTimeWindow
  } from '$src/utils/api/topDonors.util';
  import Dropdown from '$lib/components/common/dropdowns/Dropdown.svelte';

  const dropdownItemsBase: { label: string; id: TopDonorsTimeWindow }[] = [
    { label: 'This week', id: 'week' },
    { label: 'Today', id: 'day' }
  ];

  const dropdownItems: DropdownItem<TopDonorsTimeWindow>[] = dropdownItemsBase.map(
    i => new DropdownItem({ data: { label: i.label }, variant: 'label', customData: i.id })
  );

  export let topDonorsData: TopDonorsItem[] = [];
  export let selectedFilter: DropdownItem<TopDonorsTimeWindow> = dropdownItems[0];

  let loading = true;

  async function refresh() {
    loading = true;

    topDonorsData = await fetchTopDonorsItems(selectedFilter.customData);

    loading = false;
  }

  $: if (selectedFilter) refresh();
</script>

<div class="--updated-border shadow-island rounded-2xl overflow-hidden h-[500px] max-w-[330px]">
  <!-- Graphics area -->
  {#if topDonorsData}
    <div class="relative overflow-hidden h-[300px] border-[#F1F1F8] border-b">
      <div class="absolute inset-0">
        <div class="h-full translate-y-12 scale-150">
          <Rays />
        </div>
      </div>

      <div class="grid grid-cols-3 w-full h-full absolute inset-0 px-4 gap-x-6">
        <!-- One post -->
        {#if topDonorsData?.[1] || loading}
          <TopDonorsPedastol donationData={topDonorsData[1]} skelet={loading} position={2} />
        {:else}
          <div class="w-3/5" />
        {/if}

        {#if topDonorsData?.[0] || loading}
          <TopDonorsPedastol donationData={topDonorsData[0]} position={1} skelet={loading} />
        {/if}

        {#if topDonorsData?.[2] || loading}
          <TopDonorsPedastol donationData={topDonorsData[2]} position={3} skelet={loading} />
        {/if}
      </div>

      <div class="flex px-4 absolute inset-x-0 pt-4">
        <div class="flex-grow font-bold text-slate-900 whitespace-nowrap text-lg font-switzer">
          Top Seed Donors
        </div>

        <Dropdown
          variant="selected-label-with-arrow"
          bind:selected={selectedFilter}
          items={dropdownItems}
        />
      </div>
    </div>
  {/if}

  <!-- Extensive list area -->
  <div class="flex flex-col gap-y-4 pt-4 pb-8 h-[40%] overflow-y-scroll scrollbar-hide">
    {#if loading}
      <div class="--skelet-child grid gap-6 pl-4">
        <div class="w-[165px]" />
        <div class="w-[200px]" />
        <div class="w-[165px]" />
        <div class="w-[115px]" />
      </div>
    {:else}
      {#each topDonorsData || [] as donation}
        <TopDonorItem item={donation} />
      {:else}
        <div class="font-semibold text-gray-500 text-center mt-4 grid place-items-center">
          {#if topDonorsData?.[0]}
            No more top donors data to show.
          {:else}
            No top donors data to show.
          {/if}
        </div>
      {/each}
    {/if}
  </div>
</div>

<style lang="postcss">
  .--skelet-child > * {
    @apply rounded-lg h-6;
  }
</style>
